module.exports = "https://trybtryb-legacy.web.app/img/analytics.34ba047f.svg";